import React, { useState } from 'react';
import Hoverable from '../../util/Hoverable/Hoverable';
import DNAText from './DNAText';
const DNATextLink = (props) => {
    const [hovered, setIsHovered] = useState(false);
    const toggleHover = () => {
        setIsHovered((prev) => !prev);
    };
    return (<Hoverable onHoverIn={toggleHover} onHoverOut={toggleHover}>
      <DNAText {...props} style={hovered && { textDecorationLine: 'underline' }}>
        {props.children}
      </DNAText>
    </Hoverable>);
};
export default DNATextLink;
//# sourceMappingURL=DNATextLink.js.map